<template>
    <div class="row">
        <div class="col-lg-12">
            <h3 class="mt">
                <span>Застрахований об'єкт</span>
            </h3>
        </div>
        <div class="col-lg-12 row passport-row">
            <div class="col-lg-6">
                <div class="form-group">
                    <multiselect
                        :class="['form-control', 'choice_city', { invalid: (!$v.homeInfo.city.required && $v.homeInfo.city.$error) }]"
                        v-model="homeInfo.city"
                        :options="citiesOptions"
                        placeholder="Введіть назву міста"
                        @search-change="searchCities"
                        @select="getClientDataForUpdating"
                        :internal-search="false"
                        :max-height="165"
                        :options-limit="300"
                        :allow-empty="false"
                        label="name_full_name_ua"

                    />
                    <small class="error" v-if="!$v.homeInfo.city.required && $v.homeInfo.city.$error">Вкажіть місто</small>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <input
                        v-model="homeInfo.street"
                        type="text"
                        placeholder="Вул."
                        :class="['form-control', { invalid: ((!$v.homeInfo.street.required && $v.homeInfo.street.$error) || (!$v.homeInfo.street.customMinLength)) }]"
                        @change="getClientDataForUpdating"
                    />
                    <small class="error" v-if="!$v.homeInfo.street.customMinLength">Вкажіть вулицю мін. 4 літер</small>
                    <small class="error" v-if="!$v.homeInfo.street.required && $v.homeInfo.street.$error">Вкажіть вулицю</small>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <input
                        v-model="homeInfo.house"
                        v-on:keypress="LetterNumSymbolsMask"
                        type="text"
                        placeholder="Номер будинку"
                        :class="['form-control', { invalid: ((!$v.homeInfo.house.required && $v.homeInfo.house.$error) || (!$v.homeInfo.house.minLength) || (!onlyLatinCyrAndNumAndSpecials(homeInfo.house))) }]"
                        @change="getClientDataForUpdating"
                    />
                    <small class="error" v-if="!$v.homeInfo.house.required && $v.homeInfo.house.$error">Вкажіть № будинку</small>
                    <small class="error" v-if="LetterMaskError || ($v.homeInfo.house.$error && !onlyLatinCyrAndNumAndSpecials(homeInfo.house))">Тільки цифри, латинські літери, кирилиця та символи "-/"</small>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <input
                        v-model="homeInfo.apartment"
                        v-on:keypress="LetterNumSymbolsMask"
                        type="text"
                        placeholder="Квартира"
                        :class="['form-control', { invalid: ((!$v.homeInfo.apartment.minLength) || (!onlyLatinCyrAndNumAndSpecials(homeInfo.apartment))) }]"
                        @change="getClientDataForUpdating"
                    />
                    <small class="error" v-if="!$v.homeInfo.apartment.minLength && $v.homeInfo.apartment.$error">Вкажіть № квартири</small>
                    <small class="error" v-if="LetterMaskError || (!onlyLatinCyrAndNumAndSpecials(homeInfo.apartment))">Тільки цифри, латинські літери, кирилиця та символи "-/"</small>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import { minLength, required } from 'vuelidate/lib/validators';

export default {
    components: { Multiselect },
    props: ['homeInfo', 'citiesOptions', 'loading'],

    data() {
        return {
            LetterMaskError: false,
        };
    },

    model: {
        prop: 'homeInfo',
        event: 'change',
    },

    validations: {
        homeInfo: {
            city: { required, minLength: minLength(1) },
            street: {
                required,
                customMinLength(value) {
                    if (this.homeInfo.street == null || this.homeInfo.street == "") {
                        return true;
                    }
                    return value !== null && value.length >= 4;
                }
            },
            house: { required, minLength: minLength(1), onlyLatinCyrAndNumAndSpecials(value) { return this.onlyLatinCyrAndNumAndSpecials(value); } },
            apartment: { minLength: minLength(1), onlyLatinCyrAndNumAndSpecials(value) { return this.onlyLatinCyrAndNumAndSpecials(value); } },
        },
    },

    methods: {
        onlyLatinAndNumAndSpecials(str) {
            if (str == null || str == "") return true;
            return /^[a-zA-Z0-9+"'ʼ\-.\/ ]+$/.test(str);
        },

      onlyLatinCyrAndNumAndSpecials(str) {
        if (str == null || str == "") return true;
        if (/^[a-zA-Z0-9а-яґєіїА-ЯЄҐЇІ\-.\/ ]+$/.test(str)) {
          return /\d/.test(str);
        }
        return false;
      },

        errorBirthDate() {
            if (this.payer.dateBirth == "" || this.payer.dateBirth == null) {
                return false;
            }

            if ((parseInt(moment(this.payer.dateBirth, 'DD.MM.YYYY').diff(moment(), 'years')) * -1) < 18) {
                this.errors['personal.dateBirth'] = ["Страхувальнику повинно бути більше 18 років"];
                return true;
            } else if ((parseInt(moment(this.payer.dateBirth, 'DD.MM.YYYY').diff(moment(), 'years') - 1) * -1) > 100) {
                this.errors['personal.dateBirth'] = ["Страхувальнику повинно бути не більше 100 років"];
                return true;
            } else {
                return !moment(this.payer.dateBirth, 'DD.MM.YYYY').isValid();
            }
        },

        getError(name) {
            if (this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }
            return "";
        },

        onlyLatinCharactersAndNum(str) {
            if (str == null || str == "") return true;
            return /^[a-zA-Z0-9 ]+$/.test(str);
        },

      LetterNumSymbolsMask(e) {
        let char = String.fromCharCode(e.keyCode);
        if (/^[A-Za-z0-9а-яґєіїА-ЯЄҐЇІ\-.\/ ]+$/.test(char)) {
          this.LetterMaskError = false;
          return true;
        } else {
          this.LetterMaskError = true;
          e.preventDefault();
        }
      },

        selectInsuredInfo(insured) {
            this.$emit('selectInsuredInfo', insured);
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },

        searchCities(query) {
            this.$emit('searchCities', query);
        },

        getClientDataForUpdating() {
            this.$emit('getClientDataForUpdating');
        },
    },
}
</script>
